<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <router-link
        v-for="(setting, index) in minimumWageNavigation"
        :key="index"
        :to="setting.route"
        active-class="mlActiveRoute"
        style="text-decoration: none; color: black"
      >
        <div class="navigationLine py-2">
          <i
            :class="setting.symbol"
            class="fas"
          />
          {{ setting.value }}
        </div>
      </router-link>
      <a
        :href="
          $router.resolve('/contract-overview/' + contractId + '/' + versionId)
            .href
        "
        style="text-decoration: none; color: black"
      >
        <div class="navigationLine py-2">
          <i class="fas fa-home" />
          Zum Vertrag
        </div>
      </a>
    </v-navigation-drawer>
    <v-toolbar
      app
      class="configHeader"
    >
      <v-toolbar-side-icon @click="drawer = !drawer">
        <v-icon
          class="homeButton"
          color="white"
        >
          fas fa-bars
        </v-icon>
      </v-toolbar-side-icon>
      <v-toolbar-title>
        Mindestlohn-Konfiguration -
        {{ contractId }} / {{ versionId }} / {{ editionId }} -
        {{
          $store.state.mindestLohnKonfiguration.BasicContractInformation
            .contractName
        }}
        <div class="tenantInfo">
          <i>
            {{
              $store.state.mindestLohnKonfiguration.Configuration.tenantNames
            }}
          </i>
        </div>
      </v-toolbar-title>

      <div
        v-if="statusPageInfo && statusPageInfo.status"
        class="floating-element2"
      >
        <b>Status: </b> {{ statusPageInfo.status }}
        <br>
        <b>Version: </b> {{ statusPageInfo.version }}
        <br>
        <b>Veröffentlichung: </b> {{ statusPageInfo.releaseDate.split("T")[0] }}
      </div>
    </v-toolbar>

    <v-content>
      <v-container fluid>
        <div id="minimumWageConfiguration">
          <h4>{{ title }}</h4>
          <div class="ml-2 my-4">
            <router-view />
          </div>
        </div>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import { UniaGAVConstants } from "@/assets/configuration/constants.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";
import { GetStatuspageInfo } from "@/services/user.service";

export default {
  mixins: [MinimumWageMixin],
  data() {
    return {
      drawer: true,
      minimumWageNavigation: UniaGAVConstants.MinimumWageNavigation,
      navigationValue: UniaGAVConstants.MinimumWageNavigation.inputScreen.name,
      isIntEnvironment: false,
      statusPageInfo: {},
    };
  },
  computed: {
    title() {
      return this.$route.meta.title;
    },
  },
  watch: {
    "$store.state.mindestLohnKonfiguration.Configuration.editionId":
      function () {
        this.$store.dispatch("getAllValidEditionLocations", {
          contractId: this.contractId,
          versionId: this.versionId,
          editionId:
            this.$store.state.mindestLohnKonfiguration.Configuration.editionId,
        });
      },
  },
  created() {
    // initial update the vuex store
    this.$store.dispatch("getAllCities");
    this.$store.dispatch("getAllTemplates", {
      contractId: this.contractId,
      versionId: this.versionId,
      editionId: this.editionId,
    });
    this.$store.dispatch("getAllTenants");
    this.$store.dispatch("getVersionInformation", {
      contractId: this.contractId,
      versionId: this.versionId,
    });
    this.$store.dispatch("getMLConfiguration", {
      contractId: this.contractId,
      versionId: this.versionId,
      editionId: this.editionId,
    });
    this.$store.dispatch("getInputGroupings", {
      contractId: this.contractId,
      versionId: this.versionId,
      editionId: this.editionId,
    });
    this.$store.dispatch("getCriteria", {
      contractId: this.contractId,
      versionId: this.versionId,
      editionId: this.editionId,
    });
    this.$store.dispatch("getVariables", {
      contractId: this.contractId,
      versionId: this.versionId,
      editionId: this.editionId,
    });
    this.$store.dispatch("getStructure", {
      contractId: this.contractId,
      versionId: this.versionId,
      editionId: this.editionId,
    });

    if (!this.$store.state.mindestLohnKonfiguration.Configuration) {
      this.$store.dispatch("getMLConfiguration", {
        contractId: this.contractId,
        versionId: this.versionId,
        editionId: this.editionId,
      });
    }

    //Check if the environment is INT
    const url = process.env.VUE_APP_BASE_API_URL;
    this.isIntEnvironment = url.includes("int");

    if (this.isIntEnvironment) {
      GetStatuspageInfo(
        (result) => {
          if (result) {
            this.statusPageInfo = result;
          }
        },
        () => {},
      );
    }
  },
  methods: {
    ChangeVersionId(newVersionId) {
      this.versionsId = newVersionId;
    },
  },
};
</script>

<style scoped>
.floating-element2 {
  position: fixed; /* Das Element bleibt beim Scrollen sichtbar */
  top: 90%;
  right: 2%;
  color: #000000;
  transform: translateY(-50%);
  background-color: lightgrey;
  border-radius: 5px;
  padding: 20px;
  border: 1px solid #ccc;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.tenantInfo {
  font-size: 15px;
}

.navigationLineSelected {
  background-color: #eee;
  color: #ff0000;
}

.homeButton:hover {
  cursor: pointer;
}

.marginTop {
  margin-top: 50px;
}

.configHeader {
  background-color: rgb(198, 40, 40);
  color: white;
}

.navigationLine i {
  font-size: 1.4rem;
  padding: 6px 6px 6px 12px;
  width: 3rem;
}

.configHeader {
  font-size: 1rem;
  width: 100%;
  position: fixed;
  z-index: 1;
}

.navigationLine:hover {
  cursor: pointer;
  background-color: #eee;
}

.contractOverViewTabControl .shadow-sm {
  border-top: none;
  border-radius: 0px;
}

.contractOverViewTabControl {
  width: 100%;
}

.tab-pane {
  outline: none !important;
}

.navigationFloating {
  position: absolute;
  left: -56px;
  top: 100px;
  z-index: 5;
}

.mlActiveRoute {
  color: rgb(198, 40, 40) !important;
}
</style>
